import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFieldBlue20Px = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.5 8.33333C7.5 7.8731 7.8731 7.5 8.33333 7.5H11.6667C12.1269 7.5 12.5 7.8731 12.5 8.33333V11.6667C12.5 12.1269 12.1269 12.5 11.6667 12.5H8.33333C7.8731 12.5 7.5 12.1269 7.5 11.6667V8.33333Z",
		fill: "#0092E4"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.16667 2.5H5.83333V4.16667L14.1667 4.16667V2.5H15.8333V4.16667L17.5 4.16667V5.83333H15.8333V14.1667H17.5V15.8333H15.8333V17.5H14.1667V15.8333L5.83333 15.8333V17.5H4.16667V15.8333H2.5V14.1667H4.16667V5.83333H2.5V4.16667L4.16667 4.16667V2.5ZM5.83333 14.1667V5.83333L14.1667 5.83333V14.1667H5.83333Z",
		fill: "#0092E4"
	})]
});
export default SvgFieldBlue20Px;
